<template>
  <div class="city">
    <div class="banner-top">
      <pan-city :state="state" @GetSiteInfoByCityData="GetSiteInfoByCityDataVal"></pan-city>
      <swiper2 :state="state" :client="client" class="swiper-pan" :city-card="cityCard"></swiper2>
    </div>
    <div class="content-center">
      <p-title :title="title2"></p-title>
      <list :state="state" :client="client" @empty="emptyVal" :list-url="listUrl"></list>
      <div v-if="!listsEmpty" class="no-data"></div>
    </div>
    <p-footer v-if="params.cityId!=1"></p-footer>
  </div>
</template>

<script>
import panCity from '@/components/panCity'
import pTitle from '@/components/title'
import swiper2 from '@/components/swiper2'
import list from '@/components/list'
import pFooter from '@/components/footer'
export default {
  name: 'pageCity',
  props: ['client'],
  data () {
    return {
      title2: {
        title: '<span>最新</span>全景'
      },
      params: {
        cityId: 0,
        typeId: 0,
        keyWords: ''
      },
      state: 2,
      listsEmpty: true,
      listUrl: 'PanoWebService.asmx/GetLatestByCity',
      cityCard:{}
    }
  },
  components: {
    pTitle: pTitle,
    list: list,
    panCity: panCity,
    swiper2: swiper2,
    pFooter: pFooter
  },
  created () {
    let that = this;
    that.cityHrefUrl=window.location.href;
    that.publicJs.setUrlCookie('Url',window.location.href);
    that.$emit('topState', 2);
    that.paramsFun();
  },
  methods: {
    paramsFun: function () {
      let that = this;
      let routeQuery = JSON.parse(that.publicJs.decode(that.$route.query)) || {};
      this.params.typeId = routeQuery.typeId || 0;
      this.params.cityId = routeQuery.cityId || 0;
      this.params.keyWords = routeQuery.keyWords || '';
      // console.log(routeQuery)
    },
    emptyVal: function (val) {
      this.listsEmpty = val
    },
    GetSiteInfoByCityDataVal:function (val) {
      let b=JSON.parse(JSON.stringify(val)),
        that=this;
      if(b&&JSON.stringify(b)!='{}'){
        that.cityCard.name=b.charmPanoUrl?b.charmName:'';
        that.cityCard.imgSrc=b.charmPanoImg;
        that.cityCard.panoUrl=b.charmPanoUrl;
        that.cityCard.cityBool=true;
        that.cityCard.defaultBool=b.charmPanoUrl?false:true;
      }else {
        that.cityCard={}
      }
      setTimeout(function () {
      },100)
    }
  },
  watch: {
    '$route': function (newData, b) {
      this.paramsFun();
      if (newData !== b) {
        this.$root.panIndex=0;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner-top{
    background-color: white;
  }
  .swiper-pan{
    margin-top: -109px;
  }
</style>



// WEBPACK FOOTER //
// src/page/city/index.vue